import React from 'react'

export default function Section1() {
  return (
    <div className=' bg-[#F3F3F3] flex justify-center items-center lg:py-20 py-10 '>
<h1 className=' text-black lg:text-3xl text-2xl font-medium text-center w-10/12 '>
Discover the SteelX Difference: A PEB Industry Leader Welcome to SteelX, a prominent player in the PEB landscape.
</h1>
    </div>
  )
}
